import axios from "axios";

/**
 * Base URL from .env
 * REACT_APP_API_BASE_URL=http://127.0.0.1:8000
 */
const BASE = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Always include format=json for DRF
 */
const withFormat = (params = {}) => ({
  format: "json",
  ...params,
});

/* ================= COMMON METHODS ================= */
const get = (url, params) => api.get(url, { params: withFormat(params) });
const post = (url, data) => api.post(url, data);
const patch = (url, data) => api.patch(url, data);
const del = (url) => api.delete(url);

/* ================= HOSPITAL ================= */
export const listHospitals = (params) => get("/hospitals/", params);
export const createHospital = (data) => post("/hospitals/", data);
export const updateHospital = (id, data) => patch(`/hospitals/${id}/`, data);
export const deleteHospital = (id) => del(`/hospitals/${id}/`);

/* ================= WARD ================= */
export const listWards = (params) => get("/wards/", params);
export const createWard = (data) => post("/wards/", data);
export const updateWard = (id, data) => patch(`/wards/${id}/`, data);
export const deleteWard = (id) => del(`/wards/${id}/`);

/* ================= ROOM ================= */
export const listRooms = (params) => get("/rooms/", params);
export const createRoom = (data) => post("/rooms/", data);
export const updateRoom = (id, data) => patch(`/rooms/${id}/`, data);
export const deleteRoom = (id) => del(`/rooms/${id}/`);

/* ================= BED ================= */
export const listBeds = (params) => get("/beds/", params);
export const createBed = (data) => post("/beds/", data);
export const updateBed = (id, data) => patch(`/beds/${id}/`, data);
export const deleteBed = (id) => del(`/beds/${id}/`);

/* ================= DEPARTMENT ================= */
export const listDepartments = (params) => get("/departments/", params);
export const createDepartment = (data) => post("/departments/", data);
export const updateDepartment = (id, data) => patch(`/departments/${id}/`, data);
export const deleteDepartment = (id) => del(`/departments/${id}/`);

/* ================= USERS ================= */
export const getUsers = (params) => get("/users/", params);
export const createUser = (data) => post("/users/", data);
export const updateUser = (id, data) => patch(`/users/${id}/`, data);
export const deleteUser = (id) => del(`/users/${id}/`);

/* ================= USER PHOTO UPLOAD ================= */
/**
 * Upload user profile photo
 * Backend must support:
 * POST /api/users/<id>/photo/
 */
export const uploadUserPhoto = (userId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return api.post(`/users/${userId}/photo/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/* ================= ROLES ================= */
export const listRoles = (params) => get("/roles/", params);
export const createRole = (data) => post("/roles/", data);
export const updateRole = (id, data) => patch(`/roles/${id}/`, data);
export const deleteRole = (id) => del(`/roles/${id}/`);

/* ================= PERMISSIONS ================= */
export const listPermissions = (params) => get("/permissions/", params);
export const createPermission = (data) => post("/permissions/", data);
export const updatePermission = (id, data) => patch(`/permissions/${id}/`, data);
export const deletePermission = (id) => del(`/permissions/${id}/`);

/* ================= USER ROLES ================= */
export const listUserRoles = (params) => get("/user-roles/", params);
export const createUserRole = (data) => post("/user-roles/", data);
export const updateUserRole = (id, data) => patch(`/user-roles/${id}/`, data);
export const deleteUserRole = (id) => del(`/user-roles/${id}/`);

/* ================= ROLE PERMISSIONS ================= */
export const listRolePermissions = (params) => get("/role-permissions/", params);
export const createRolePermission = (data) => post("/role-permissions/", data);
export const updateRolePermission = (id, data) => patch(`/role-permissions/${id}/`, data);
export const deleteRolePermission = (id) => del(`/role-permissions/${id}/`);